import React from 'react';
import { View } from 'react-native';
import { UserGroup } from '../../../../../../../../constants/Types';
import Option from './Option';

interface ChangeGroupListProps {
  groups: UserGroup[],
  tags: string[],
  itemIndex: number,
  update,
}

const ChangeGroupList = ({
  groups, tags, itemIndex, update,
}: ChangeGroupListProps) => <View testID='select-issue-user-groups-list'>
    {groups.filter((group: UserGroup) => !tags?.includes(group.UserGroupId))
      .map((group, index: number) => <Option
        text={group.Name}
        key={`user_group_option_${group.UserGroupId}`}
        selected={tags?.length && group.UserGroupId === tags[itemIndex]}
        onPress={() => update(group.UserGroupId)}
        testID={`template-issue-user-group-option#${index + 1}`}
      />)}
  </View>;

export default ChangeGroupList;
